import { createContext, type ReactNode } from 'react';

export interface ModalContextType {
  openModal: (component: ReactNode, onDismiss?: () => void) => void;
  closeModal: () => void;
  closeModalWithoutAnimation: () => void;
  isModalOpen: boolean;
}

export const ModalContext = createContext<ModalContextType | undefined>(undefined);
